import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllCities from "../../Components/Admin/AdminAllCities";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllCitiesPage = () => {
  return (
    <AdminAllCities />
  );
};

export default AdminAllCitiesPage;